<template>
    <div class="header_expenses_analysis is-full-width px-5 py-2">
        <p class="title">Análisis de Gastos</p>

        <div class="right_cluster is-flex is-align-items-center">
            <div v-if="endMonth" class="calendar_picker is-flex is-align-items-center">
                <AnualCalendar
                    :value="endMonth"
                    :disableNewerDates="true"
                    :disabledFrom="getNow"
                    formatLabelDate="MMMM YYYY"
                    :alignRight="true"
                    @date-change="onDateChange" />
            </div>

            <button class="export_btn ml-3 is-flex is-align-items-center" disabled title="Próximamente">
                <DownloadFile class="mr-2 export_icon" />
                Exportar
            </button>

            <button class="close_btn ml-3" aria-label="Cerrar modal" @click="$emit('close-modal')">
                <Ecs class="ecs" />
            </button>
        </div>
    </div>
</template>

<script>
import Ecs from "@/components/svg/Ecs.vue";
import DownloadFile from "@/components/svg/DownloadFile.vue";
import AnualCalendar from "@/components/classification/AnualCalendar.vue";

export default {
    name: "HeaderExpensesAnalysis",
    components: { Ecs, DownloadFile, AnualCalendar },
    props: {
        // Shape esperado por ModalFullHeightRight.headerProps: periodLabel,
        // endMonth, getNow (sin filtros de categoría, a diferencia de Ventas).
        payload: {
            type: Object,
            default: () => ({
                periodLabel: "",
                endMonth: null,
                getNow: null,
            }),
        },
    },
    computed: {
        periodLabel() {
            return this.payload?.periodLabel ?? "";
        },
        endMonth() {
            return this.payload?.endMonth ?? null;
        },
        getNow() {
            return this.payload?.getNow ?? null;
        },
    },
    methods: {
        onDateChange(date) {
            this.$emit("update-end-month", date);
        },
    },
};
</script>

<style scoped lang="scss">
.header_expenses_analysis {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.title {
    color: var(--report-text);
    font-size: 28px;
    font-weight: 700;
    margin: 0;
}

.calendar_picker {
    border-radius: 8px;
}

.export_btn {
    background: var(--report-bg);
    border: 1px solid var(--report-border);
    border-radius: 8px;
    padding: 6px 14px;
    font-size: 14px;
    font-weight: 500;
    color: var(--report-text-muted-strong);
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
    cursor: pointer;
    transition: background-color 0.15s ease;
    height: 46px;

    &:hover {
        background: var(--report-surface);
    }

    &[disabled] {
        opacity: 0.55;
        cursor: not-allowed;
    }
}

.export_icon {
    width: 16px;
    height: 16px;
}

.close_btn {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid var(--report-border-soft);
    background: var(--report-bg);
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
    box-sizing: border-box;
    overflow: hidden;
    padding-top: 5px;
    cursor: pointer;

    .ecs {
        width: 100%;
        position: relative;
        height: 20px;
        overflow: hidden;
        flex-shrink: 0;
    }
}
</style>
